import { getFlatTourBookingInfo } from './getFlatTourBookingInfo';
import { IAppState } from '../../common/state';

export function getIsFlatTourBookingEnabled(state: IAppState): boolean {
  const flatTourBookingInfo = getFlatTourBookingInfo(state);

  return flatTourBookingInfo?.isEnabled || false;
}
